import React from 'react';
import { connect } from 'react-redux';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField } from '@material-ui/core';
import LoadingOverlay from 'react-loading-overlay';
import { parsePhoneNumberFromString } from 'libphonenumber-js'

class TwoFactorLoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: true,
            isSubmittingVerificationCode: false,
            verified: false,
            preferredPhone: "",
            error: "",
            verificationCode: "",
            phoneNumberObject: {},
            overlayStatus: "initializing",
            disabled: true
        }
        this.handleVerification = this.handleVerification.bind(this);
        this.onChangeVerificationCode = this.onChangeVerificationCode.bind(this);
        this.sendSmsVerification = this.sendSmsVerification.bind(this);
    }
    
    componentDidMount() {
        let { match: { params } } = this.props;

        let transactionId = params.transactionId;
        if (transactionId) {
            const transactionUrl = `api/case/${transactionId}/contact/preferredPhone`;
            this.setState({
                isSubmittingVerificationCode: true
            });
            fetch(transactionUrl)
            .then(res => res.json())
            .then(
                (result) => {
                    const phoneNumber = parsePhoneNumberFromString(result.phoneNumber);
                    this.setState({
                        preferredPhone: phoneNumber.number,
                        phoneNumberObject: phoneNumber
                    });

                    this.sendSmsVerification();
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isSubmittingVerificationCode: false,
                        error: error.toString()
                    });
                }
            )
        }
    }
    
    sendSmsVerification() {
        this.setState({
            error: ""
        });
        var requestParams = {
            method: 'POST'
        }
        let countryCode = this.state.phoneNumberObject.countryCallingCode;
        let nationalNumber = this.state.phoneNumberObject.nationalNumber;
        fetch(`api/authy/${countryCode}/${nationalNumber}`, requestParams)
            .then(res2 => res2.json())
            .then((result2) => {
                this.setState({
                    isSubmittingVerificationCode: false
                });
        });
    }
    
    onChangeVerificationCode(event) {
        this.setState({
            verificationCode: event.target.value
        });
        
        if (event.target.value && event.target.value.trim().length > 0 && event.target.value.length > 0) {
            this.setState({
                disabled: false
            });
        } else {
            this.setState({
                disabled: true
            });
        }
    }
    
    handleVerification() {
        let { phoneNumberObject, verificationCode } = this.state;
        this.setState({
            isSubmittingVerificationCode: true,
            overlayStatus: "submitting",
            error: ""
        });
        
        let requestParams = {
            method: 'GET'
        }
        fetch(`api/authy/${phoneNumberObject.countryCallingCode}/${phoneNumberObject.nationalNumber}/${verificationCode}`, requestParams)
        .then(res => res.json(),
            (error) => {
                this.setState({
                    isSubmittingVerificationCode: false,
                    error: error.toString()
                });
            }
        )
        .then(
            (result) => {
                this.setState({
                    isSubmittingVerificationCode: false
                });
                var resultObj = JSON.parse(result);

                if (resultObj.success) {
                    this.setState({
                        verified: true
                    })
                } else {
                    this.setState({
                        error: "Verification code is wrong, please click on 'Resend Code' to try again!"
                    })
                }
            },
            (error) => {
                this.setState({
                    isSubmittingVerificationCode: false,
                    error: error.toString()
                });
            }
        );
    }
    
    render() {
        let { modalOpen, isSubmittingVerificationCode, error, preferredPhone, verificationCode, overlayStatus, disabled } = this.state;
        let preferredPhoneLength = preferredPhone.length;
        let maskedPhone = preferredPhone.substr(0, 5) + '-###-' + preferredPhone.substr(8, preferredPhoneLength-7);
        
        let overlayText = "";
        if (overlayStatus === "initializing") {
            overlayText = "Loading multi factor authentication... Please wait..."
        } else if (overlayStatus === "submitting") {
            overlayText = "Verifying... Please wait..."
        }
        
        return (
            <Dialog open={modalOpen} aria-labelledby="form-dialog-title">
                <LoadingOverlay active={isSubmittingVerificationCode} spinner text={overlayText}>
                    <DialogTitle id="form-dialog-title">Multi-Factor Verification</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please enter the verification code you received on the phone {maskedPhone}:
                        </DialogContentText>
                        </DialogContent>
                        <TextField
                            error={error !== undefined && error.length > 0}
                            helperText={error}
                            margin="normal"
                            id="verificationCode"
                            label="Verification Code"
                            type="string"
                            style={{    marginLeft: 24,
                                marginRight: 24,
                                width: 200}}
                            required
                            fullWidth
                            value={verificationCode}
                            onChange={this.onChangeVerificationCode}
                    />
                    <DialogActions>
                        { error ?
                        <Button variant="contained" color="primary" onClick={this.sendSmsVerification}>
                            Resend Code
                        </Button> : null }
                        <Button variant="contained" color="primary" onClick={this.handleVerification} disabled={disabled}>
                            Submit
                        </Button>
                    </DialogActions>
                </LoadingOverlay>
            </Dialog>
        )
    }    
}

export default connect()(TwoFactorLoginPage)
